import { TextInput } from 'common-front/src/designSystem/components/textInput';
import { RichSelect } from 'common-front/src/designSystem/form/richSelect';
import { useHeavent } from 'common-front/src/hooks/useHeavent';
import { useStateDebounce } from 'common-front/src/hooks/useStateDebounce';
import { useUsersSearch } from 'common-front/src/users/search/useUsersSearch';
import { Box } from 'common/src/designSystem/components/box';
import { Spacer } from 'common/src/designSystem/components/spacer';
import { CampaignType, UsersInfoId } from 'common/src/generated/types';
import { isNonEmptyArray } from 'common/src/util/array';
import * as React from 'react';

interface ICampaignUsersRecipientsProps {
    campaignType: CampaignType;
    recipients: string;
    usersInfosIds: UsersInfoId[];
}

export const CampaignUsersRecipients = (props: ICampaignUsersRecipientsProps) => {
    const {
        translate,
        params: { organizationId, eventId }
    } = useHeavent();
    const [name, nameDebounced, setName] = useStateDebounce('');
    const { usersInfosOptions, isLoading } = useUsersSearch({
        organizationId,
        eventId,
        includePhone: props.campaignType === CampaignType.Sms,
        hasSelected: isNonEmptyArray(props.usersInfosIds),
        nameDebounced,
        userInfoIds: props.usersInfosIds
    });

    if (props.recipients === 'users') {
        return (
            <>
                <Spacer height="2" />

                <Box css={{ marginLeft: '$6' }}>
                    <RichSelect
                        isSearchLoading={isLoading}
                        isSearchVisible={true}
                        multiple={true}
                        name="campaign.usersInfosIds"
                        placeholder={translate('ajouter_des_mem_58427')}
                        searchElement={
                            <TextInput
                                icon="magnifying-glass"
                                name={name}
                                placeholder={translate('rechercher_un_m_05904')}
                                state="search"
                                onChange={setName}
                            />
                        }
                    >
                        {usersInfosOptions}
                    </RichSelect>
                </Box>
            </>
        );
    } else {
        return null;
    }
};
